import Occupants from './occupants';
import MoveInInformation from './moveInInfo';
import Pets from './pets';
import Vehicles from './vehicles';
import CurrentResidency from './currentResidency';
import EmploymentInformation from './employmentInformation';
import UploadDocuments from './uploadDocuments';
import EmergencyContact from './emergencyContact';
import landingPage from '../landingPage';
import Review from './review';
import ThankyouPage from './../thankyouPage';




export default {
    "landingPage": landingPage,
    "occupants": Occupants,
    "moveInInformation": MoveInInformation,
    "pets": Pets,
    "vehicles": Vehicles,
    "currentResidency": CurrentResidency,
    "employmentInformations": EmploymentInformation,
    "emergencyContacts": EmergencyContact,
    "uploadedDoc": UploadDocuments,
    "review": Review,
    "thankyouPage": ThankyouPage,
}

export {
    Occupants,
    MoveInInformation,
    Pets,
    Vehicles,
    CurrentResidency,
    EmploymentInformation,
    EmergencyContact,
    UploadDocuments,
}
